import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useTranslation } from 'react-i18next';
import { IRegionalRate } from '../types';

interface RegionalRateFormProps {
  regionalRate: IRegionalRate;
  onSubmit: (data: any) => void;
}

export const RegionalRateForm = ({ regionalRate, onSubmit }: RegionalRateFormProps) => {
  const { t } = useTranslation();

  return (
    <>
      {regionalRate && (
        <EnhancedForm onSubmit={onSubmit} edit={!!regionalRate.id} autoStyleLayout columns={2}>
          <IdentityField
            name="code"
            component={TextFieldAdapter}
            initialValue={regionalRate.code}
            label={t('global.code')}
            type="text"
          />
          <IdentityField
            name="rate"
            component={TextFieldAdapter}
            initialValue={regionalRate.rate}
            label={t('entities.regional_rate.rate')}
            type="text"
          />
          <IdentityField
            gridSpan={2}
            name="description"
            component={TextFieldAdapter}
            initialValue={regionalRate.description}
            label={t('global.description')}
            type="text"
          />
        </EnhancedForm>
      )}
    </>
  );
};

export default RegionalRateForm;
